<script>
import * as LucideIcons from 'lucide-vue-next'

export default {
  name: 'LegacyLucideIcon',
  props: {
    name: { type: String, default: '' },
    size: { type: [Number, String], default: 20 },
    strokeWidth: { type: [Number, String], default: 2 },
    color: { type: String, default: 'currentColor' },
  },
  computed: {
    iconComponent() {
      return this.name ? LucideIcons[this.name] : null
    },
    pixelSize() {
      const n = Number(this.size)
      // legacy callers passed 6 expecting tailwind h-6 (24px); be tolerant of small numbers
      if (Number.isFinite(n) && n > 0 && n <= 12) return n * 4
      return n || 20
    },
  },
}
</script>

<template>
  <component
    v-if="iconComponent"
    :is="iconComponent"
    :size="pixelSize"
    :stroke-width="strokeWidth"
    :color="color"
  />
</template>
